const SELECTORS = {
    block: '.wp-block-ssm-category-list',
    item: '[data-category-item]',
    trigger: '[data-category-trigger]',
    panel: '[data-category-panel]',
};

const CLASSES = { open: 'is-open' };

const setItemState = (item, isOpen, trigger, panel) => {
    item.classList.toggle(CLASSES.open, isOpen);

    if (trigger) trigger.setAttribute('aria-expanded', String(isOpen));
    if (panel) panel.setAttribute('aria-hidden', String(!isOpen));
};

export const initCategoryList = (block) => {
    if (!block || block.dataset.categoryListReady) return null;

    block.dataset.categoryListReady = 'true';

    const items = Array.from(block.querySelectorAll(SELECTORS.item));
    if (!items.length) return null;

    const cleanupHandlers = [];

    items.forEach((item) => {
        const trigger = item.querySelector(SELECTORS.trigger);
        const panel = item.querySelector(SELECTORS.panel);

        setItemState(item, true, trigger, panel);

        if (!trigger) return;

        const onClick = (e) => {
            if (e.target.closest('a')) return;
            const isOpen = item.classList.contains(CLASSES.open);
            setItemState(item, !isOpen, trigger, panel);
        };

        const onKeydown = (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const isOpen = item.classList.contains(CLASSES.open);
                setItemState(item, !isOpen, trigger, panel);
            }
        };

        trigger.addEventListener('click', onClick);
        trigger.addEventListener('keydown', onKeydown);
        cleanupHandlers.push(() => {
            trigger.removeEventListener('click', onClick);
            trigger.removeEventListener('keydown', onKeydown);
        });
    });

    return {
        destroy() {
            cleanupHandlers.forEach((fn) => fn());
            items.forEach((item) => {
                const trigger = item.querySelector(SELECTORS.trigger);
                const panel = item.querySelector(SELECTORS.panel);
                setItemState(item, false, trigger, panel);
            });
            delete block.dataset.categoryListReady;
        },
    };
};

export const CategoryList = () => {
    document.querySelectorAll(SELECTORS.block).forEach(initCategoryList);
};
